import { HTTP_TOKEN_REPORT } from "./http";

export const getTrackings = (params) => {
  return HTTP_TOKEN_REPORT.get("tracking", { params }).then((result) => {
    return result.data;
  });
};

export const getTrackingsLead = (params) => {
  return HTTP_TOKEN_REPORT.get("tracking-lead", { params }).then((result) => {
    return result.data;
  });
};



export const getTrackingsWhats = (params) => {
  return HTTP_TOKEN_REPORT.get("tracking-whats", { params }).then((result) => {
    return result.data;
  });
};



